import { Controller } from 'stimulus';
import $ from 'jquery';

export default class extends Controller {
  connect() {
    $(this.element).selectize({
      plugins: ['remove_button'],
      persist: false,
      render: {
        item: (data, escape) => `<div class="field__tag-item">${escape(data.text)}</div>`,
      },
    });
  }

  disconnect() {
    this.element.selectize?.destroy();
  }
}
